import Helmet from "react-helmet"
import ReactMarkdown from "react-markdown"

import PageContainer from "@podcastsoundboard/ps-lib/components/PageContainer"

import DeviceChips from "@podcastsoundboard/ps-lib/components/DeviceChips/DeviceChips"
import { useNavigate } from "react-router"
import AppBar from "../../components/AppBar"
import Footer from "../../components/Footer"
import { useAppSelector } from "../../redux"
import HomeContent from "../Home/components/HomeContent"
import mobileChangelogMarkdown from "./mobileChangelogMarkdown"
import {
  Box,
  Container,
  Divider,
  Paper,
  Toolbar,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"

export default function WindowsChangelog() {
  const darkModeEnabled = useAppSelector((state) => state.darkModeEnabled)
  const navigate = useNavigate()

  return (
    <PageContainer darkModeEnabled={darkModeEnabled}>
      <Helmet titleTemplate="%s">
        <title>Podcast Soundboard for Mobile Changelog</title>
        <meta
          name="description"
          content="Podcast Soundboard is the best soundboard application, available on all platforms. Featuring many customization and control options and a money-back guarantee."
        />
      </Helmet>

      <Box>
        <AppBar
          showLogo
          invert
          title="Podcast Soundboard"
          typographyColorOverride="white"
        />
        <Box className="pb-20">
          <Toolbar />

          <Container maxWidth="lg" className="py-8">
            <DeviceChips
              handleOpenUrl={(url) => window.open(url, "_blank")}
              navigate={navigate}
            />
            <Paper elevation={4} className="py-4 px-8 mt-8">
              <Typography
                variant="h2"
                style={{ color: "white" }}
                className="mb-4"
              >
                Mobile Changelog (Android & iOS)
              </Typography>

              <ReactMarkdown>{mobileChangelogMarkdown}</ReactMarkdown>
            </Paper>
          </Container>
        </Box>

        <HomeContent />
        <Divider />
        <Footer />
      </Box>
    </PageContainer>
  )
}
